// import React, { useEffect, useState } from "react";
// import $ from "jquery";
// import { useDispatch, useSelector } from "react-redux";
// import { setload_Screen, Show_MsgBox } from "./features/Message";
// import adminApp, { API_URL, DecryptData, Logout_User } from "./Utility";
// import { useNavigate } from "react-router-dom";
// import moment from "moment";

// function SideMenu() {
//   const navigate  = useNavigate();
//   const dispatch  = useDispatch();
//   const _common   = useSelector((store) => store.Common);

//   const [arrEntPer,      setarrEntPer]      = useState([]);
//   const [IsLogOut,       setIsLogOut]       = useState(false);

//   // ── Hide Settings Panel States ─────────────────────────────────────────
//   const [showHidePanel,  setShowHidePanel]  = useState(false);
//   const [activeTab,      setActiveTab]      = useState("reports"); // "reports" | "screens"
//   const [arrClients,     setArrClients]     = useState([]);
//   const [selectedClient, setSelectedClient] = useState("");
//   const [arrReports,     setArrReports]     = useState([]);
//   const [arrScreens,     setArrScreens]     = useState([]);

//   useEffect(() => { Load_Permissions(); }, []);
//   useEffect(() => { if (IsLogOut) Logout_User(); }, [IsLogOut]);

//   // ── Load Menu Permissions ──────────────────────────────────────────────
//   const Load_Permissions = async () => {
//     try {
//       let authparem = await DecryptData(localStorage.jbctlparm);
//       await dispatch(setload_Screen(true));
//       await adminApp
//         .get(`UserMaster/Admin_AutoLogout/${Number(authparem.User)}`)
//         .then(async (res) => {
//           if (res.data.strStatus === "Success") {
//             setIsLogOut(res.data.AutoLogOut);
//             setarrEntPer(JSON.parse(authparem.mnper));
//           } else {
//             AlertMessage(res.data.strMessage, "error");
//           }
//         });
//     } catch (err) {
//       AlertMessage(err.message, "error");
//     } finally {
//       await dispatch(setload_Screen(false));
//     }
//   };

//   const MenuClick = (Index) => {
//     $(`.nav-item`).removeClass("active");
//     $(`.nav-item:eq(${Index})`).addClass("active");
//   };

//   const AlertMessage = (Message, Icon) => {
//     dispatch(Show_MsgBox({ Message: Message, Type: Icon, isMsg: true }));
//   };

//   const menuIcons = (ScrId) => {
//     switch (ScrId) {
//       case 1:  return <i className="bx bx-buildings"></i>;
//       case 2:  return <i className="bx bx-user"></i>;
//       case 3:  return <i className="bx bx-news"></i>;
//       case 4:  return <i className="fas fa-envelope"></i>;
//       case 5:  return <i className="fa-solid fa-users"></i>;
//       case 6:  return <i className="fa-solid fa-server"></i>;
//       case 7:  return <i className="bx bxs-hdd"></i>;
//       case 8:  return <i className="fa-solid fa-scroll"></i>;
//       case 9:  return <i className="bx bx-cloud-upload"></i>;
//       case 10: return <i className="bx bx-error"></i>;
//       default: break;
//     }
//   };

//   // ── Server Actions ─────────────────────────────────────────────────────
//   const Backup_Server = async () => {
//     try {
//       await dispatch(setload_Screen(true));
//       await fetch(`${API_URL}DBMaster/Backup_Server`, {
//         method: "GET",
//         headers: {
//           Authorization: `Bearer ${localStorage.jbadmparetkau}`,
//           "Content-Type": "application/json",
//         },
//       })
//         .then((res) => res.blob())
//         .then((res) => {
//           const url  = window.URL.createObjectURL(res);
//           const link = document.createElement("a");
//           link.href  = url;
//           const now       = moment();
//           const curr_date = now.format("D-MMM-YYYY");
//           link.setAttribute("download", `JustBill_${curr_date}.zip`);
//           link.click();
//         })
//         .catch(async (err) => {
//           await dispatch(Show_MsgBox({ Message: err.stack, Type: "error", isMsg: true }));
//         });
//     } catch (err) {
//       await dispatch(Show_MsgBox({ Message: err.message, Type: "error", isMsg: true }));
//     } finally {
//       await dispatch(setload_Screen(false));
//     }
//   };

//   const Restart_App = async () => {
//     try {
//       await dispatch(setload_Screen(true));
//       await adminApp.get("ClientMaster/Restart_App").then((res) => {
//         if (res.data.strStatus === "Success") AlertMessage(res.data.strMessage, "success");
//         else AlertMessage(res.data.strMessage, "error");
//       });
//     } catch (err) {
//       AlertMessage(err.message, "error");
//     } finally {
//       await dispatch(setload_Screen(false));
//     }
//   };

//   const Shoutdown_App = async () => {
//     try {
//       await dispatch(setload_Screen(true));
//       await adminApp.get("ClientMaster/Restart_App").then((res) => {
//         if (res.data.strStatus === "Success") AlertMessage(res.data.strMessage, "success");
//         else AlertMessage(res.data.strMessage, "error");
//       });
//     } catch (err) {
//       AlertMessage(err.message, "error");
//     } finally {
//       await dispatch(setload_Screen(false));
//     }
//   };

//   // ── Hide Panel: Open (load client list) ───────────────────────────────
//   const Open_HidePanel = async () => {
//     try {
//       await dispatch(setload_Screen(true));
//       // reuses ClientMaster/Load_Clients — same endpoint, already exists
//       await adminApp.get("ClientMaster/Load_HideClients").then((res) => {
//         if (res.data.strStatus === "Success") {
//           setArrClients(res.data.Clients);
//           setSelectedClient("");
//           setArrReports([]);
//           setArrScreens([]);
//           setActiveTab("reports");
//           setShowHidePanel(true);
//         } else {
//           AlertMessage(res.data.strMessage, "error");
//         }
//       });
//     } catch (err) {
//       AlertMessage(err.message, "error");
//     } finally {
//       await dispatch(setload_Screen(false));
//     }
//   };

//   // ── Client Dropdown Change ─────────────────────────────────────────────
//   // selectedClient stores { ClientId, strMasterDB } object
//   const Handle_ClientChange = async (e) => {
//    const selected = arrClients.find(
//   (c) => String(c.clientId) === e.target.value
// );
//     setSelectedClient(selected || "");
//     setArrReports([]);
//     setArrScreens([]);
//     if (!selected) return;
//     if (activeTab === "reports") await Load_Reports(selected.strMasterDB);
//     else await Load_Screens(selected.strMasterDB);
//   };

//   // ── Tab Switch ────────────────────────────────────────────────────────
//   const Handle_TabChange = async (tab) => {
//     setActiveTab(tab);
//     if (!selectedClient) return;
//     if (tab === "reports" && arrReports.length === 0) await Load_Reports(selectedClient.strMasterDB);
//     if (tab === "screens" && arrScreens.length === 0) await Load_Screens(selectedClient.strMasterDB);
//   };

//   // ── Load Reports ──────────────────────────────────────────────────────
//   const Load_Reports = async (strMasterDB) => {
//     try {
//       await dispatch(setload_Screen(true));
//       await adminApp.get(`ClientMaster/Load_ReportPermissions/${strMasterDB}`).then((res) => {
//         if (res.data.strStatus === "Success") setArrReports(res.data.Reports);
//         else AlertMessage(res.data.strMessage, "error");
//       });
//     } catch (err) {
//       AlertMessage(err.message, "error");
//     } finally {
//       await dispatch(setload_Screen(false));
//     }
//   };

//   // ── Load Screens ──────────────────────────────────────────────────────
//   const Load_Screens = async (strMasterDB) => {
//     try {
//       await dispatch(setload_Screen(true));
//       await adminApp.get(`ClientMaster/Load_ScreenPermissions/${strMasterDB}`).then((res) => {
//         if (res.data.strStatus === "Success") setArrScreens(res.data.Screens);
//         else AlertMessage(res.data.strMessage, "error");
//       });
//     } catch (err) {
//       AlertMessage(err.message, "error");
//     } finally {
//       await dispatch(setload_Screen(false));
//     }
//   };

//   // ── Checkbox Toggles ─────────────────────────────────────────────────
//   const Toggle_Report = (RptPerId) => {
//     setArrReports((prev) =>
//       prev.map((r) =>
//         r.rptPerId === RptPerId? { ...r, showReport: r.showReport === 1 ? 0 : 1 } : r
//       )
//     );
//   };

// const Toggle_Screen = (scrPerId) => {
//   setArrScreens((prev) =>
//     prev.map((s) =>
//       s.scrPerId === scrPerId
//         ? { ...s, showScreen: s.showScreen === 1 ? 0 : 1 }
//         : s
//     )
//   );
// };

//   // ── Select All / Deselect All helpers ────────────────────────────────
//   const ToggleAll_Reports = (hideAll) => {
//     setArrReports((prev) => prev.map((r) => ({ ...r, showReport: hideAll ? 0 : 1 })));
//   };

// const ToggleAll_Screens = (hideAll) => {
//   setArrScreens((prev) =>
//     prev.map((s) => ({
//       ...s,
//       showScreen: hideAll ? 0 : 1,
//     }))
//   );
// };

//   // ── Save Reports ─────────────────────────────────────────────────────
//   const Save_ReportPermissions = async () => {
//     if (!selectedClient) { AlertMessage("Please select a client", "error"); return; }
//     try {
//       await dispatch(setload_Screen(true));
//       await adminApp
//         .post("ClientMaster/Update_ReportPermissions", {
//           strMasterDB: selectedClient.strMasterDB,
//           Reports: arrReports,
//         })
//         .then((res) => {
//           if (res.data.strStatus === "Success") {
//             AlertMessage(res.data.strMessage, "success");
//             setShowHidePanel(false);
//           } else {
//             AlertMessage(res.data.strMessage, "error");
//           }
//         });
//     } catch (err) {
//       AlertMessage(err.message, "error");
//     } finally {
//       await dispatch(setload_Screen(false));
//     }
//   };

//   // ── Save Screens ─────────────────────────────────────────────────────
// const Save_ScreenPermissions = async () => {
//   if (!selectedClient) {
//     AlertMessage("Please select a client", "error");
//     return;
//   }

//   try {
//     await dispatch(setload_Screen(true));

//     await adminApp
//       .post("ClientMaster/Update_ScreenPermissions", {
//         strMasterDB: selectedClient.strMasterDB,

//         Screens: arrScreens.map((s) => ({
//           ScrPerId: s.scrPerId,
//           ScrId: s.scrId,
//           ScrName: s.scrName,
//           ShowScreen: s.showScreen,
//         })),
//       })
//       .then((res) => {
//         if (res.data.strStatus === "Success") {
//           AlertMessage(res.data.strMessage, "success");
//           setShowHidePanel(false);
//         } else {
//           AlertMessage(res.data.strMessage, "error");
//         }
//       });
//   } catch (err) {
//     AlertMessage(err.message, "error");
//   } finally {
//     await dispatch(setload_Screen(false));
//   }
// };

//   // ── Counts for badge display ──────────────────────────────────────────
//   const hiddenReportCount  = arrReports.filter((r) => r.showReport === 0).length;
//   const hiddenScreenCount = arrScreens.filter(
//   (s) => Number(s.showScreen) === 0
// ).length;

//   // ─────────────────────────────────────────────────────────────────────
//   return (
//     <>
//       {/* ── TOP HEADER ──────────────────────────────────────────────── */}
//       <header className="top-menu">
//         <h1>{_common.ScrName}</h1>
//         <div className="header-icon">
//           {_common.permission.IsBackup && (
//             <span
//               className="hicon"
//               onClick={() =>
//                 dispatch(Show_MsgBox({ Button: Backup_Server, Question: `Do You Want to Backup Server Data?`, isdialog: true }))
//               }
//             >
//               <i className="fa-solid fa-server"></i>
//               <span className="tooltip bottom">Backup Server</span>
//             </span>
//           )}
//           {_common.permission.IsBackup && (
//             <span
//               className="hicon"
//               onClick={() =>
//                 dispatch(Show_MsgBox({ Button: Restart_App, Question: `Do You Want to Restart App?`, isdialog: true }))
//               }
//             >
//               <i className="fa-solid fa-rotate-right"></i>
//               <span className="tooltip bottom">Restart App</span>
//             </span>
//           )}
//           {_common.permission.IsBackup && (
//             <span
//               className="hicon"
//               onClick={() =>
//                 dispatch(Show_MsgBox({ Button: Shoutdown_App, Question: `Do You Want to Shoutdown App?`, isdialog: true }))
//               }
//             >
//               <i className="fa-solid fa-power-off"></i>
//               <span className="tooltip bottom">Shoutdown App</span>
//             </span>
//           )}
//           <span className="hicon" onClick={() => Logout_User()}>
//             <i className="bx bx-log-out"></i>
//             <span className="tooltip bottom">SignOut</span>
//           </span>
//         </div>
//       </header>

//       {/* ── SIDEBAR NAV ─────────────────────────────────────────────── */}
//       <nav>
//         <div className="btn-bars">
//           <span
//             className="fas fa-bars third"
//             onClick={() => {
//               $(".btn-bars").toggleClass("click");
//               $("nav").toggleClass("show");
//             }}
//           ></span>
//         </div>
//         <div className="nav-header">
//           <h3>JustBill C-Panel</h3>
//         </div>
//         <ul>
//           {arrEntPer
//   .filter((per) => Number(per.showScreen ?? 1) === 1)
//   .map((per, Index) => (
//             <li key={Index} className={Index === 0 ? "nav-item active" : "nav-item"}>
//               <span
//                 onClick={async () => {
//                   MenuClick(Index);
//                   await Load_Permissions();
//                   if (window.location.pathname !== `/admin${per.menuPath}`)
//                     navigate(`/admin${per.menuPath}`);
//                 }}
//               >
//                 {menuIcons(per.scrId)}
//                 {per.scrName}
//               </span>
//             </li>
//           ))}

//           {/* ── Hide Settings menu item — Super Admin only ── */}
//           {_common.permission.IsBackup && (
//             <li className="nav-item">
//               <span onClick={Open_HidePanel} style={{ cursor: "pointer" }}>
//                 <i className="bx bx-hide"></i>
//                 Hide Settings
//               </span>
//             </li>
//           )}
//         </ul>
//       </nav>

//       {/* ── HIDE SETTINGS MODAL ──────────────────────────────────────── */}
//       {showHidePanel && (
//         <div className="hp-overlay">
//           <div className="hp-panel">

//             {/* Header */}
//             <div className="hp-header">
//               <h2><i className="bx bx-hide"></i>&nbsp;Hide Settings</h2>
//               <button className="hp-close-btn" onClick={() => setShowHidePanel(false)}>
//                 <i className="bx bx-x"></i>
//               </button>
//             </div>

//             {/* Client Selector */}
//             <div className="hp-client-row">
//               <label>Client</label>
//               <select
//   value={selectedClient?.clientId || ""}
//   onChange={Handle_ClientChange}
// >
//   <option value="">-- Select Client --</option>

//   {arrClients.map((c) => (
//     <option key={c.clientId} value={c.clientId}>
//       {`${c.clientName} (ID: ${c.clientId})`}
//     </option>
//   ))}
// </select>
//             </div>

//             {/* Tabs: Screens | Reports */}
//             <div className="hp-tabs">
//               <button
//                 className={`hp-tab-btn ${activeTab === "screens" ? "active" : ""}`}
//                 onClick={() => Handle_TabChange("screens")}
//               >
//                 <i className="bx bx-layout"></i>
//                 &nbsp;Screens
//                 {hiddenScreenCount > 0 && (
//                   <span className="hp-tab-badge">{hiddenScreenCount} hidden</span>
//                 )}
//               </button>
//               <button
//                 className={`hp-tab-btn ${activeTab === "reports" ? "active" : ""}`}
//                 onClick={() => Handle_TabChange("reports")}
//               >
//                 <i className="fa-solid fa-scroll"></i>
//                 &nbsp;Reports
//                 {hiddenReportCount > 0 && (
//                   <span className="hp-tab-badge">{hiddenReportCount} hidden</span>
//                 )}
//               </button>
//             </div>

//             {/* ── SCREENS TAB CONTENT ── */}
//             {activeTab === "screens" && (
//               <>
//                 {selectedClient && arrScreens.length > 0 && (
//                   <div className="hp-bulk-row">
//                     <span className="hp-bulk-label">
//                       {arrScreens.filter((s) => s.showScreen === 0).length} of {arrScreens.length} hidden
//                     </span>
//                     <button className="hp-bulk-btn" onClick={() => ToggleAll_Screens(true)}>Hide All</button>
//                     <button className="hp-bulk-btn" onClick={() => ToggleAll_Screens(false)}>Show All</button>
//                   </div>
//                 )}
//                 <div className="hp-list">
//                   {!selectedClient ? (
//                     <p className="hp-empty"><i className="bx bx-user"></i><br />Select a client to load screens</p>
//                   ) : arrScreens.length === 0 ? (
//                     <p className="hp-empty">No screens found for this client.</p>
//                   ) : (
//                     arrScreens.map((scr) => (
//                       <div key={scr.scrPerId} className="hp-item">
//                         <label className="hp-check-label">
//                           <input
//                             type="checkbox"
//                         checked={Number(scr.showScreen) === 0}
//                             onChange={() => Toggle_Screen(scr.scrPerId)}
//                           />
//                           <span className="hp-item-name">{scr.scrName}</span>
//                           {Number(scr.showScreen) === 0
//                             ? <span className="hp-badge hidden">Hidden</span>
//                             : <span className="hp-badge visible">Visible</span>
//                           }
//                         </label>
//                       </div>
//                     ))
//                   )}
//                 </div>
//                 {arrScreens.length > 0 && (
//                   <div className="hp-footer">
//                     <button className="hp-cancel-btn" onClick={() => setShowHidePanel(false)}>Cancel</button>
//                     <button
//                       className="hp-save-btn"
//                       onClick={() =>
//                         dispatch(Show_MsgBox({
//                           Button: Save_ScreenPermissions,
//                           Question: "Save screen visibility changes for this client?",
//                           isdialog: true,
//                         }))
//                       }
//                     >
//                       <i className="bx bx-save"></i>&nbsp;Save Screens
//                     </button>
//                   </div>
//                 )}
//               </>
//             )}

//             {/* ── REPORTS TAB CONTENT ── */}
//             {activeTab === "reports" && (
//               <>
//                 {selectedClient && arrReports.length > 0 && (
//                   <div className="hp-bulk-row">
//                     <span className="hp-bulk-label">
//                       {arrReports.filter((r) => r.showReport === 0).length} of {arrReports.length} hidden
//                     </span>
//                     <button className="hp-bulk-btn" onClick={() => ToggleAll_Reports(true)}>Hide All</button>
//                     <button className="hp-bulk-btn" onClick={() => ToggleAll_Reports(false)}>Show All</button>
//                   </div>
//                 )}
//                 <div className="hp-list">
//                   {!selectedClient ? (
//                     <p className="hp-empty"><i className="bx bx-user"></i><br />Select a client to load reports</p>
//                   ) : arrReports.length === 0 ? (
//                     <p className="hp-empty">No reports found for this client.</p>
//                   ) : (
//            arrReports.map((rpt) => (
//   <div key={rpt.rptPerId} className="hp-item">
//     <label className="hp-check-label">
//       <input
//         type="checkbox"
//         checked={rpt.showReport === 0}
//         onChange={() => Toggle_Report(rpt.rptPerId)}
//       />

//       <span className="hp-item-name">
//         {rpt.rptName}
//       </span>

//       {rpt.showReport === 0 ? (
//         <span className="hp-badge hidden">Hidden</span>
//       ) : (
//         <span className="hp-badge visible">Visible</span>
//       )}
//     </label>
//   </div>
// ))
//                   )}
//                 </div>
//                 {arrReports.length > 0 && (
//                   <div className="hp-footer">
//                     <button className="hp-cancel-btn" onClick={() => setShowHidePanel(false)}>Cancel</button>
//                     <button
//                       className="hp-save-btn"
//                       onClick={() =>
//                         dispatch(Show_MsgBox({
//                           Button: Save_ReportPermissions,
//                           Question: "Save report visibility changes for this client?",
//                           isdialog: true,
//                         }))
//                       }
//                     >
//                       <i className="bx bx-save"></i>&nbsp;Save Reports
//                     </button>
//                   </div>
//                 )}
//               </>
//             )}

//           </div>

//           {/* ── All CSS scoped inside the modal ── */}
//           <style>{`
// /* ── Overlay ── */
//   .hp-overlay {
//     position: fixed; inset: 0;
//     background: rgba(0, 0, 0, 0.60);
//     z-index: 9999;
//     display: flex; align-items: center; justify-content: center;
//   }
 
//   /* ── Panel container ── */
//   .hp-panel {
//     background: #fff;
//     border-radius: 10px;
//     width: 520px; max-width: 96vw; max-height: 88vh;
//     display: flex; flex-direction: column;
//     box-shadow: 0 12px 48px rgba(0, 0, 0, 0.30);
//     overflow: hidden;
//   }
 
//   /* ── Header — dark green like the sidebar ── */
//   .hp-header {
//     display: flex; align-items: center; justify-content: space-between;
//     padding: 14px 20px;
//     background: #1a5c1a;           /* ← sidebar dark green */
//     border-bottom: none;
//   }
//   .hp-header h2 {
//     margin: 0; font-size: 15px; font-weight: 700;
//     color: #ffffff;
//     display: flex; align-items: center; gap: 8px;
//   }
//   .hp-header h2 i { font-size: 17px; }
 
//   /* ── Close button ── */
//   .hp-close-btn {
//     background: rgba(255,255,255,0.15);
//     border: none; font-size: 22px;
//     cursor: pointer; color: #ffffff;
//     border-radius: 6px; padding: 2px 7px; line-height: 1;
//     transition: background 0.15s;
//   }
//   .hp-close-btn:hover { background: rgba(255,255,255,0.30); }
 
//   /* ── Client selector row ── */
//   .hp-client-row {
//     display: flex; align-items: center; gap: 12px;
//     padding: 12px 20px;
//     border-bottom: 1px solid #e5e7eb;
//     background: #f4faf4;           /* very light green tint */
//   }
//   .hp-client-row label {
//     font-size: 13px; font-weight: 600;
//     color: #1a5c1a; white-space: nowrap;
//   }
//   .hp-client-row select {
//     flex: 1; padding: 8px 10px;
//     border: 1px solid #a7d7a7;    /* green-tinted border */
//     border-radius: 7px;
//     font-size: 13px; color: #1e293b;
//     outline: none; background: #fff;
//     transition: border 0.15s;
//   }
//   .hp-client-row select:focus { border-color: #1a5c1a; }
 
//   /* ── Tabs ── */
//   .hp-tabs {
//     display: flex;
//     border-bottom: 2px solid #e5e7eb;
//     background: #f8fdf8;
//     padding: 0 20px;
//   }
//   .hp-tab-btn {
//     padding: 10px 20px; border: none; background: none;
//     font-size: 13px; font-weight: 600; color: #64748b;
//     cursor: pointer;
//     border-bottom: 3px solid transparent;
//     margin-bottom: -2px;
//     display: flex; align-items: center; gap: 6px;
//     transition: color 0.15s, border-color 0.15s;
//   }
//   .hp-tab-btn.active {
//     color: #1a5c1a;                /* ← green active text */
//     border-bottom-color: #1a5c1a; /* ← green underline   */
//   }
//   .hp-tab-btn:hover:not(.active) { color: #2d7a2d; }
 
//   /* ── Badge on tab (hidden count) ── */
//   .hp-tab-badge {
//     font-size: 10px; font-weight: 700;
//     background: #fee2e2; color: #dc2626;
//     border-radius: 10px; padding: 1px 7px;
//     margin-left: 4px;
//   }
 
//   /* ── Bulk row (Hide All / Show All) ── */
//   .hp-bulk-row {
//     display: flex; align-items: center; gap: 8px;
//     padding: 8px 20px;
//     background: #edf7ed;           /* light green tint */
//     border-bottom: 1px solid #d1ead1;
//   }
//   .hp-bulk-label { font-size: 12px; color: #3a6b3a; flex: 1; }
//   .hp-bulk-btn {
//     font-size: 11px; font-weight: 600; padding: 4px 12px;
//     border: 1px solid #a7d7a7; border-radius: 5px;
//     background: #fff; color: #1a5c1a; cursor: pointer;
//     transition: background 0.12s;
//   }
//   .hp-bulk-btn:hover { background: #d4efd4; }
 
//   /* ── Scrollable list ── */
//   .hp-list {
//     flex: 1; overflow-y: auto; padding: 4px 20px;
//   }
//   .hp-empty {
//     text-align: center; color: #94a3b8;
//     font-size: 13px; padding: 36px 0; line-height: 2.2;
//   }
//   .hp-item {
//     padding: 9px 0;
//     border-bottom: 1px solid #f1f5f9;
//   }
//   .hp-item:last-child { border-bottom: none; }
 
//   /* ── Checkbox row ── */
//   .hp-check-label {
//     display: flex; align-items: center; gap: 10px;
//     cursor: pointer; font-size: 13px; color: #1e293b; user-select: none;
//   }
//   .hp-check-label input[type="checkbox"] {
//     width: 15px; height: 15px;
//     cursor: pointer;
//     accent-color: #1a5c1a;        /* ← green checkmark */
//     flex-shrink: 0;
//   }
//   .hp-item-name { flex: 1; }
 
//   /* ── Visible / Hidden badges ── */
//   .hp-badge {
//     font-size: 11px; padding: 2px 9px;
//     border-radius: 10px; font-weight: 600; white-space: nowrap;
//   }
//   .hp-badge.hidden  { background: #fee2e2; color: #dc2626; }
//   .hp-badge.visible { background: #dcfce7; color: #16a34a; }
 
//   /* ── Footer ── */
//   .hp-footer {
//     display: flex; justify-content: flex-end; gap: 10px;
//     padding: 12px 20px;
//     border-top: 1px solid #d1ead1;
//     background: #f4faf4;
//   }
//   .hp-cancel-btn {
//     padding: 8px 18px;
//     border: 1px solid #a7d7a7; border-radius: 7px;
//     background: #fff; font-size: 13px; cursor: pointer; color: #374151;
//     transition: background 0.12s;
//   }
//   .hp-cancel-btn:hover { background: #edf7ed; }
//   .hp-save-btn {
//     padding: 8px 20px; border: none;
//     background: #1a5c1a;           /* ← dark green, matches sidebar */
//     color: #fff;
//     border-radius: 7px; font-size: 13px; font-weight: 700;
//     cursor: pointer; display: flex; align-items: center; gap: 6px;
//     transition: background 0.15s;
//   }
//   .hp-save-btn:hover { background: #14491a; }
//           `}</style>
//         </div>
//       )}
//     </>
//   );
// }

// export default SideMenu;


import React, { useEffect, useState } from "react";
import $ from "jquery";
import { useDispatch, useSelector } from "react-redux";
import { setload_Screen, Show_MsgBox } from "./features/Message";
import adminApp, { API_URL, DecryptData, Logout_User } from "./Utility";
import { useNavigate } from "react-router-dom";
import moment from "moment";

// Props: showHidePanel, onOpenHide, onCloseHide — passed from ProtectedRoute
function SideMenu({ showHidePanel, onOpenHide, onCloseHide }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const _common  = useSelector((store) => store.Common);

  const [arrEntPer, setarrEntPer] = useState([]);
  const [IsLogOut,  setIsLogOut]  = useState(false);

  useEffect(() => { Load_Permissions(); }, []);
  useEffect(() => { if (IsLogOut) Logout_User(); }, [IsLogOut]);

  const Load_Permissions = async () => {
    try {
      let authparem = await DecryptData(localStorage.jbctlparm);
      await dispatch(setload_Screen(true));
      await adminApp
        .get(`UserMaster/Admin_AutoLogout/${Number(authparem.User)}`)
        .then(async (res) => {
          if (res.data.strStatus === "Success") {
            setIsLogOut(res.data.AutoLogOut);
            setarrEntPer(JSON.parse(authparem.mnper));
          } else {
            AlertMessage(res.data.strMessage, "error");
          }
        });
    } catch (err) {
      AlertMessage(err.message, "error");
    } finally {
      await dispatch(setload_Screen(false));
    }
  };

  const MenuClick = (Index) => {
    $(`.nav-item`).removeClass("active");
    $(`.nav-item:eq(${Index})`).addClass("active");
  };

  const AlertMessage = (Message, Icon) =>
    dispatch(Show_MsgBox({ Message, Type: Icon, isMsg: true }));

  const menuIcons = (ScrId) => {
    switch (ScrId) {
      case 1:  return <i className="bx bx-buildings"></i>;
      case 2:  return <i className="bx bx-user"></i>;
      case 3:  return <i className="bx bx-news"></i>;
      case 4:  return <i className="fas fa-envelope"></i>;
      case 5:  return <i className="fa-solid fa-users"></i>;
      case 6:  return <i className="fa-solid fa-server"></i>;
      case 7:  return <i className="bx bxs-hdd"></i>;
      case 8:  return <i className="fa-solid fa-scroll"></i>;
      case 9:  return <i className="bx bx-cloud-upload"></i>;
      case 10: return <i className="bx bx-error"></i>;
      default: return null;
    }
  };

  const Backup_Server = async () => {
    try {
      await dispatch(setload_Screen(true));
      await fetch(`${API_URL}DBMaster/Backup_Server`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.jbadmparetkau}`,
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.blob())
        .then((res) => {
          const url  = window.URL.createObjectURL(res);
          const link = document.createElement("a");
          link.href  = url;
          const curr_date = moment().format("D-MMM-YYYY");
          link.setAttribute("download", `JustBill_${curr_date}.zip`);
          link.click();
        })
        .catch(async (err) => {
          await dispatch(Show_MsgBox({ Message: err.stack, Type: "error", isMsg: true }));
        });
    } catch (err) {
      await dispatch(Show_MsgBox({ Message: err.message, Type: "error", isMsg: true }));
    } finally {
      await dispatch(setload_Screen(false));
    }
  };

  const Restart_App = async () => {
    try {
      await dispatch(setload_Screen(true));
      await adminApp.get("ClientMaster/Restart_App").then((res) => {
        if (res.data.strStatus === "Success") AlertMessage(res.data.strMessage, "success");
        else AlertMessage(res.data.strMessage, "error");
      });
    } catch (err) {
      AlertMessage(err.message, "error");
    } finally {
      await dispatch(setload_Screen(false));
    }
  };

  const Shoutdown_App = async () => {
    try {
      await dispatch(setload_Screen(true));
      await adminApp.get("ClientMaster/Restart_App").then((res) => {
        if (res.data.strStatus === "Success") AlertMessage(res.data.strMessage, "success");
        else AlertMessage(res.data.strMessage, "error");
      });
    } catch (err) {
      AlertMessage(err.message, "error");
    } finally {
      await dispatch(setload_Screen(false));
    }
  };

  return (
    <>
      {/* ── TOP HEADER ── */}
      <header className="top-menu">
        <h1>{showHidePanel ? "Hide Settings" : _common.ScrName}</h1>
        <div className="header-icon">
          {_common.permission.IsBackup && (
            <span className="hicon"
              onClick={() => dispatch(Show_MsgBox({ Button: Backup_Server, Question: `Do You Want to Backup Server Data?`, isdialog: true }))}>
              <i className="fa-solid fa-server"></i>
              <span className="tooltip bottom">Backup Server</span>
            </span>
          )}
          {_common.permission.IsBackup && (
            <span className="hicon"
              onClick={() => dispatch(Show_MsgBox({ Button: Restart_App, Question: `Do You Want to Restart App?`, isdialog: true }))}>
              <i className="fa-solid fa-rotate-right"></i>
              <span className="tooltip bottom">Restart App</span>
            </span>
          )}
          {_common.permission.IsBackup && (
            <span className="hicon"
              onClick={() => dispatch(Show_MsgBox({ Button: Shoutdown_App, Question: `Do You Want to Shoutdown App?`, isdialog: true }))}>
              <i className="fa-solid fa-power-off"></i>
              <span className="tooltip bottom">Shoutdown App</span>
            </span>
          )}
          <span className="hicon" onClick={() => Logout_User()}>
            <i className="bx bx-log-out"></i>
            <span className="tooltip bottom">SignOut</span>
          </span>
        </div>
      </header>

      {/* ── SIDEBAR NAV ── */}
      <nav>
        <div className="btn-bars">
          <span className="fas fa-bars third"
            onClick={() => {
              $(".btn-bars").toggleClass("click");
              $("nav").toggleClass("show");
            }}
          ></span>
        </div>
        <div className="nav-header">
          <h3>JustBill C-Panel</h3>
        </div>
        <ul>
          {arrEntPer
            .filter((per) => Number(per.showScreen ?? 1) === 1)
            .map((per, Index) => (
              <li key={Index}
                className={`nav-item${Index === 0 && !showHidePanel ? " active" : ""}`}>
                <span
                  onClick={async () => {
                    onCloseHide();          // Hide Settings close பண்ணு
                    MenuClick(Index);
                    await Load_Permissions();
                    if (window.location.pathname !== `/admin${per.menuPath}`)
                      navigate(`/admin${per.menuPath}`);
                  }}
                >
                  {menuIcons(per.scrId)}
                  {per.scrName}
                </span>
              </li>
            ))}

          {/* ── Hide Settings — Super Admin only ── */}
          {_common.permission.IsBackup && (
            <li className={`nav-item${showHidePanel ? " active" : ""}`}>
              <span onClick={onOpenHide} style={{ cursor: "pointer" }}>
                <i className="bx bx-hide"></i>
                Hide Settings
              </span>
            </li>
          )}
        </ul>
      </nav>
    </>
  );
}

export default SideMenu;



// import React, { useEffect, useState } from "react";
// import $ from "jquery";
// import { useDispatch, useSelector } from "react-redux";
// import { setload_Screen, Show_MsgBox } from "./features/Message";
// import adminApp, { API_URL, DecryptData, Logout_User } from "./Utility";
// import { useNavigate } from "react-router-dom";
// import { LoadDefaultstates } from "./features/Common";
// import moment from "moment";

// function SideMenu() {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const _common = useSelector((store) => store.Common);
//   const [arrEntPer, setarrEntPer] = useState([]);
//   const [IsLogOut, setIsLogOut] = useState(false);

//   // ── Report Hide Panel States ──────────────────────────────────────
//   const [showReportPanel, setshowReportPanel] = useState(false);
//   const [arrClients, setArrClients]           = useState([]);
//   const [selectedClient, setSelectedClient]   = useState("");
//   const [arrReports, setArrReports]           = useState([]);

//   useEffect(() => { Load_Permissions(); }, []);
//   useEffect(() => { if (IsLogOut) Logout_User(); }, [IsLogOut]);

//   const Load_Permissions = async () => {
//     try {
//       let authparem = await DecryptData(localStorage.jbctlparm);
//       await dispatch(setload_Screen(true));
//       await adminApp
//         .get(`UserMaster/Admin_AutoLogout/${Number(authparem.User)}`)
//         .then(async (res) => {
//           if (res.data.strStatus === "Success") {
//             setIsLogOut(res.data.AutoLogOut);
//             setarrEntPer(JSON.parse(authparem.mnper));
//           } else {
//             AlertMessage(res.data.strMessage, "error");
//           }
//         });
//     } catch (err) {
//       AlertMessage(err.message, "error");
//     } finally {
//       await dispatch(setload_Screen(false));
//     }
//   };

//   const MenuClick = (Index) => {
//     $(`.nav-item`).removeClass("active");
//     $(`.nav-item:eq(${Index})`).addClass("active");
//   };

//   const AlertMessage = (Message, Icon) => {
//     dispatch(Show_MsgBox({ Message: Message, Type: Icon, isMsg: true }));
//   };

//   const menuIcons = (ScrId) => {
//     switch (ScrId) {
//       case 1:  return <i className="bx bx-buildings"></i>;
//       case 2:  return <i className="bx bx-user"></i>;
//       case 3:  return <i className="bx bx-news"></i>;
//       case 4:  return <i className="fas fa-envelope"></i>;
//       case 5:  return <i className="fa-solid fa-users"></i>;
//       case 6:  return <i className="fa-solid fa-server"></i>;
//       case 7:  return <i className="bx bxs-hdd"></i>;
//       case 8:  return <i className="fa-solid fa-scroll"></i>;
//       case 9:  return <i className="bx bx-cloud-upload"></i>;
//       case 10: return <i className="bx bx-error"></i>;
//       default: break;
//     }
//   };

//   const Backup_Server = async () => {
//     try {
//       await dispatch(setload_Screen(true));
//       await fetch(`${API_URL}DBMaster/Backup_Server`, {
//         method: "GET",
//         headers: {
//           Authorization: `Bearer ${localStorage.jbadmparetkau}`,
//           "Content-Type": "application/json",
//         },
//       })
//         .then((res) => res.blob())
//         .then((res) => {
//           const url = window.URL.createObjectURL(res);
//           const link = document.createElement("a");
//           link.href = url;
//           const now = moment();
//           const curr_date = now.format("D-MMM-YYYY");
//           const FileName = `JustBill_${curr_date}.zip`;
//           link.setAttribute("download", FileName);
//           link.click();
//         })
//         .catch(async (err) => {
//           await dispatch(Show_MsgBox({ Message: err.stack, Type: "error", isMsg: true }));
//         });
//     } catch (err) {
//       await dispatch(Show_MsgBox({ Message: err.message, Type: "error", isMsg: true }));
//     } finally {
//       await dispatch(setload_Screen(false));
//     }
//   };

//   const Restart_App = async () => {
//     try {
//       await dispatch(setload_Screen(true));
//       await adminApp.get("ClientMaster/Restart_App").then((res) => {
//         if (res.data.strStatus === "Success") AlertMessage(res.data.strMessage, "success");
//         else AlertMessage(res.data.strMessage, "error");
//       });
//     } catch (err) {
//       AlertMessage(err.message, "error");
//     } finally {
//       await dispatch(setload_Screen(false));
//     }
//   };

//   const Shoutdown_App = async () => {
//     try {
//       await dispatch(setload_Screen(true));
//       await adminApp.get("ClientMaster/Restart_App").then((res) => {
//         if (res.data.strStatus === "Success") AlertMessage(res.data.strMessage, "success");
//         else AlertMessage(res.data.strMessage, "error");
//       });
//     } catch (err) {
//       AlertMessage(err.message, "error");
//     } finally {
//       await dispatch(setload_Screen(false));
//     }
//   };

//   // ── 1. Open panel: load client list from JB_Master ───────────────
//   const Open_ReportPanel = async () => {
//     try {
//       await dispatch(setload_Screen(true));
//       await adminApp.get("ReportPermissions/GetClients").then((res) => {
//         if (res.data.strStatus === "Success") {
//           setArrClients(res.data.data);
//           setSelectedClient("");
//           setArrReports([]);
//           setshowReportPanel(true);
//         } else {
//           AlertMessage(res.data.strMessage, "error");
//         }
//       });
//     } catch (err) {
//       AlertMessage(err.message, "error");
//     } finally {
//       await dispatch(setload_Screen(false));
//     }
//   };

//   // ── 2. Client dropdown change: load reports from JB_MS_{clientId} ─
//   const Load_Reports = async (clientId) => {
//     setSelectedClient(clientId);
//     if (!clientId) { setArrReports([]); return; }
//     try {
//       await dispatch(setload_Screen(true));
//       await adminApp.get(`ReportPermissions/GetReports/${clientId}`).then((res) => {
//         if (res.data.strStatus === "Success") setArrReports(res.data.data);
//         else AlertMessage(res.data.strMessage, "error");
//       });
//     } catch (err) {
//       AlertMessage(err.message, "error");
//     } finally {
//       await dispatch(setload_Screen(false));
//     }
//   };

//   // ── 3. Checkbox toggle: checked = hidden (showReport=0), unchecked = visible (showReport=1)
//   const Toggle_Report = (RptPerId) => {
//     setArrReports((prev) =>
//       prev.map((r) =>
//         r.RptPerId === RptPerId
//           ? { ...r, showReport: r.showReport === 1 ? 0 : 1 }
//           : r
//       )
//     );
//   };

//   // ── 4. Save: POST updated list → UPDATE rb_tbl_reportspermissions ─
//   const Save_ReportPermissions = async () => {
//     if (!selectedClient) { AlertMessage("Please select a client", "error"); return; }
//     try {
//       await dispatch(setload_Screen(true));
//       await adminApp
//         .post("ReportPermissions/UpdateReports", {
//           clientId: selectedClient,
//           reports: arrReports.map((r) => ({
//             RptPerId: r.RptPerId,
//             showReport: r.showReport,
//           })),
//         })
//         .then((res) => {
//           if (res.data.strStatus === "Success") {
//             AlertMessage(res.data.strMessage, "success");
//             setshowReportPanel(false);
//           } else {
//             AlertMessage(res.data.strMessage, "error");
//           }
//         });
//     } catch (err) {
//       AlertMessage(err.message, "error");
//     } finally {
//       await dispatch(setload_Screen(false));
//     }
//   };

//   return (
//     <>
//       <header className="top-menu">
//         <h1>{_common.ScrName}</h1>
//         <div className="header-icon">
//           {_common.permission.IsBackup && (
//             <span className="hicon" onClick={() => dispatch(Show_MsgBox({ Button: Backup_Server, Question: `Do You Want to Backup Server Data?`, isdialog: true }))}>
//               <i className="fa-solid fa-server"></i>
//               <span className="tooltip bottom">Backup Server</span>
//             </span>
//           )}
//           {_common.permission.IsBackup && (
//             <span className="hicon" onClick={() => dispatch(Show_MsgBox({ Button: Restart_App, Question: `Do You Want to Restart App?`, isdialog: true }))}>
//               <i className="fa-solid fa-rotate-right"></i>
//               <span className="tooltip bottom">Restart App</span>
//             </span>
//           )}
//           {_common.permission.IsBackup && (
//             <span className="hicon" onClick={() => dispatch(Show_MsgBox({ Button: Shoutdown_App, Question: `Do You Want to Shoutdown App?`, isdialog: true }))}>
//               <i className="fa-solid fa-power-off"></i>
//               <span className="tooltip bottom">Shoutdown App</span>
//             </span>
//           )}
//           <span className="hicon" onClick={() => Logout_User()}>
//             <i className="bx bx-log-out"></i>
//             <span className="tooltip bottom">SignOut</span>
//           </span>
//         </div>
//       </header>

//       <nav>
//         <div className="btn-bars">
//           <span
//             className="fas fa-bars third"
//             onClick={() => {
//               $(".btn-bars").toggleClass("click");
//               $("nav").toggleClass("show");
//             }}
//           ></span>
//         </div>
//         <div className="nav-header">
//           <h3>JustBill C-Panel</h3>
//         </div>
//         <ul>
//           {arrEntPer.map((per, Index) => (
//             <li key={Index} className={Index === 0 ? "nav-item active" : "nav-item"}>
//               <span
//                 onClick={async () => {
//                   MenuClick(Index);
//                   await Load_Permissions();
//                   if (window.location.pathname !== `/admin${per.menuPath}`)
//                     navigate(`/admin${per.menuPath}`);
//                 }}
//               >
//                 {menuIcons(per.scrId)}
//                 {per.scrName}
//               </span>
//             </li>
//           ))}

//           {/* ── NEW: Report Hide menu item — only super admin sees this ── */}
//           {_common.permission.IsBackup && (
//             <li className="nav-item">
//               <span onClick={Open_ReportPanel} style={{ cursor: "pointer" }}>
//                 <i className="bx bx-hide"></i>
//                 Report Hide
//               </span>
//             </li>
//           )}
//         </ul>
//       </nav>

//       {/* ── Report Hide Modal ─────────────────────────────────────────── */}
//       {showReportPanel && (
//         <div className="report-hide-overlay">
//           <div className="report-hide-panel">

//             {/* Header */}
//             <div className="rhp-header">
//               <h2><i className="bx bx-hide"></i>&nbsp; Report Hide Settings</h2>
//               <button className="rhp-close-btn" onClick={() => setshowReportPanel(false)}>
//                 <i className="bx bx-x"></i>
//               </button>
//             </div>

//             {/* Client Selector */}
//             <div className="rhp-client-row">
//               <label>Client</label>
//               <select value={selectedClient} onChange={(e) => Load_Reports(e.target.value)}>
//                 <option value="">-- Select Client --</option>
//                 {arrClients.map((c) => (
//                   <option key={c.ClientId} value={c.ClientId}>
//                     {c.ClientName} &nbsp;(ID: {c.ClientId})
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Reports List with checkboxes */}
//             <div className="rhp-report-list">
//               {arrReports.length === 0 ? (
//                 <p className="rhp-empty">
//                   {selectedClient ? "No reports found for this client." : "Select a client to load reports."}
//                 </p>
//               ) : (
//                 arrReports.map((rpt) => (
//                   <div key={rpt.RptPerId} className="rhp-report-item">
//                     <label className="rhp-checkbox-label">
//                       <input
//                         type="checkbox"
//                         checked={rpt.showReport === 0}  
//                         onChange={() => Toggle_Report(rpt.RptPerId)}
//                       />
//                       <span className="rhp-rpt-name">{rpt.RptName}</span>
//                       {rpt.showReport === 0
//                         ? <span className="rhp-badge hidden">Hidden</span>
//                         : <span className="rhp-badge visible">Visible</span>
//                       }
//                     </label>
//                   </div>
//                 ))
//               )}
//             </div>

//             {/* Save / Cancel */}
//             {arrReports.length > 0 && (
//               <div className="rhp-footer">
//                 <button className="rhp-cancel-btn" onClick={() => setshowReportPanel(false)}>
//                   Cancel
//                 </button>
//                 <button
//                   className="rhp-save-btn"
//                   onClick={() =>
//                     dispatch(Show_MsgBox({
//                       Button: Save_ReportPermissions,
//                       Question: "Save report visibility changes for this client?",
//                       isdialog: true,
//                     }))
//                   }
//                 >
//                   <i className="bx bx-save"></i>&nbsp;Save Changes
//                 </button>
//               </div>
//             )}
//           </div>

//           <style>{`
//             .report-hide-overlay {
//               position: fixed; inset: 0;
//               background: rgba(0,0,0,0.55);
//               z-index: 9999;
//               display: flex; align-items: center; justify-content: center;
//             }
//             .report-hide-panel {
//               background: #fff; border-radius: 10px;
//               width: 500px; max-width: 95vw; max-height: 85vh;
//               display: flex; flex-direction: column;
//               box-shadow: 0 8px 32px rgba(0,0,0,0.22);
//               overflow: hidden;
//             }
//             .rhp-header {
//               display: flex; align-items: center; justify-content: space-between;
//               padding: 14px 18px; border-bottom: 1px solid #e5e7eb;
//               background: #f8fafc;
//             }
//             .rhp-header h2 {
//               margin: 0; font-size: 15px; font-weight: 600;
//               color: #1e293b; display: flex; align-items: center;
//             }
//             .rhp-close-btn {
//               background: none; border: none; font-size: 22px;
//               cursor: pointer; color: #64748b;
//               border-radius: 4px; padding: 2px 5px; line-height: 1;
//             }
//             .rhp-close-btn:hover { background: #e2e8f0; color: #1e293b; }
//             .rhp-client-row {
//               display: flex; align-items: center; gap: 12px;
//               padding: 12px 18px; border-bottom: 1px solid #e5e7eb;
//             }
//             .rhp-client-row label {
//               font-size: 13px; font-weight: 600;
//               color: #374151; white-space: nowrap;
//             }
//             .rhp-client-row select {
//               flex: 1; padding: 7px 10px;
//               border: 1px solid #d1d5db; border-radius: 6px;
//               font-size: 13px; color: #1e293b; outline: none;
//               background: #fff;
//             }
//             .rhp-client-row select:focus { border-color: #6366f1; }
//             .rhp-report-list {
//               flex: 1; overflow-y: auto; padding: 6px 18px;
//             }
//             .rhp-empty {
//               text-align: center; color: #94a3b8;
//               font-size: 13px; padding: 30px 0;
//             }
//             .rhp-report-item {
//               padding: 9px 0; border-bottom: 1px solid #f1f5f9;
//             }
//             .rhp-report-item:last-child { border-bottom: none; }
//             .rhp-checkbox-label {
//               display: flex; align-items: center; gap: 10px;
//               cursor: pointer; font-size: 13px; color: #1e293b; user-select: none;
//             }
//             .rhp-checkbox-label input[type="checkbox"] {
//               width: 15px; height: 15px;
//               cursor: pointer; accent-color: #6366f1; flex-shrink: 0;
//             }
//             .rhp-rpt-name { flex: 1; }
//             .rhp-badge {
//               font-size: 11px; padding: 2px 9px;
//               border-radius: 10px; font-weight: 600; white-space: nowrap;
//             }
//             .rhp-badge.hidden  { background: #fee2e2; color: #dc2626; }
//             .rhp-badge.visible { background: #dcfce7; color: #16a34a; }
//             .rhp-footer {
//               display: flex; justify-content: flex-end; gap: 10px;
//               padding: 12px 18px; border-top: 1px solid #e5e7eb;
//               background: #f8fafc;
//             }
//             .rhp-cancel-btn {
//               padding: 8px 16px; border: 1px solid #d1d5db;
//               background: #fff; border-radius: 6px;
//               font-size: 13px; cursor: pointer; color: #374151;
//             }
//             .rhp-cancel-btn:hover { background: #f1f5f9; }
//             .rhp-save-btn {
//               padding: 8px 18px; border: none;
//               background: #6366f1; color: #fff;
//               border-radius: 6px; font-size: 13px; font-weight: 600;
//               cursor: pointer; display: flex; align-items: center;
//             }
//             .rhp-save-btn:hover { background: #4f46e5; }
//           `}</style>
//         </div>
//       )}
//     </>
//   );
// }

// export default SideMenu;